import type { EmotionalProtocolLogRepository } from '../../../application/ports/EmotionalProtocolLogRepository';
import type { EmotionalProtocolLog } from '../../../domain/emotion/EmotionalProtocolLog';
import type { ProfileId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { EmotionalProtocolLogMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieEmotionalProtocolLogRepository implements EmotionalProtocolLogRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(log: EmotionalProtocolLog): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.emotionalProtocolLogs.put(EmotionalProtocolLogMapper.toRecord(log));
    });
  }

  public findByLogicalDate(
    profileId: ProfileId,
    logicalDate: string,
  ): Promise<EmotionalProtocolLog | null> {
    return executePersistence('read', async () => {
      const record = await this.database.emotionalProtocolLogs
        .where('[profileId+logicalDate]')
        .equals([profileId, logicalDate])
        .first();
      return record ? EmotionalProtocolLogMapper.fromRecord(record) : null;
    });
  }
}
